export const getAuthorizationStatus = state => state.authorization.isAuthorized;

export const getAccessToken = state => state.authorization.accessToken;

export const getRefreshToken = state => state.authorization.refreshToken;

export const getTwoStepData = state => state.authorization.twoStepData;
